var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn-next"},[_vm._t("btn-name",function(){return [_vm._v("下一頁")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }